export const newsData = {
  title: "Aktuality",
};